module.exports = "/packs/iphone-landscape-72127a16c8385c80c07f0f6bbc4b153a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/iphone-landscape.png
// module id = ./app/javascript/packs/Shared/assets/images/iphone-landscape.png
// module chunks = 1